<script>

import config from "@/helpers/config"
export default {
    created() {
        this.$cache.createCache('userOwnerCourses', 'user-owner-courses/') 
    },
    data() {
        return {          
          
        }
    },
    methods: {
        goTopage(courseItem)
        {       
            this.$router.push({ name: 'ownerCoursesDetails', params: { id: courseItem.id } })
        }  
    },
    computed: {
        userOwnerCourses() {  return this.$store.state.userOwnerCourses == null ? [] : this.$store.state.userOwnerCourses; },
        url() { return config.urlToServer },
        customer() { return this.$store.state.customer; }    
    }
}
</script>
<template>
    <div v-fade-in>
        <main class="opacity-white-bg">
        <section>
            <h2>Dina {{this.$store.state.settings.Course.plural}}</h2>               
        </section>
        <div class="OwnerCourses-wrapper">
                    <div v-for="course in userOwnerCourses" class="OwnerCourses-booking-item"> 
                        <div @mouseover="course.hovered = true" @mouseout="course.hovered = false">
                            <div class="position-relative">
                                <div class="OwnerCourses-img-area">
                                    <img v-if="course.image_id" :src="url + 'uploads/'+ customer.id+'/images/thumbnails/'+ course.image_name" />  
                                    <i v-else class="fa-regular fa-image wow-color wow-color-bg"></i>
                                </div>
                                <h4 class="wow-color">{{ course.name }}</h4>
                            </div>
                            <div class="OwnerCourses-max-booking" v-if="!course.course_has_ended">
                                <label>Antal anmälda</label>
                                <b>{{ course.participants.length }} av {{ course.max_number_of_participents }}</b> <b style="color: red" v-if="course.participants.some(x => !x.approved)"> - {{  course.participants.filter(x => !x.approved).length }} anmälningar väntar på godkännande</b>
                                <label>Kursstart</label>
                                <b> {{ course.course_start }}</b>
                                <label> Nästa kurstillfälle</label>
                                <b>{{course.next_occation.duration }}</b>                       
                                <button class="btn float-right margin-top-15" @click="goTopage(course)">Hantera deltagare</button>
                            </div>
                            <div v-else>
                                <br><br>
                                <h2 style="text-warning">Kursen är avslutad</h2>
                                <button class="btn float-right margin-top-15" @click="goTopage(course)">Visa deltagarlistan</button>
                            </div>
                        </div>              
                    </div>
                </div>
        </main>
    </div>
</template>
<style scoped>
label {
    display: block;
    margin: 10px 0px 3px 0px;
}
.OwnerCourses-wrapper
    {
        display:flex;
        flex-wrap: wrap;
    }

    .OwnerCourses-booking-item
    {
        padding:10px; 
        margin: 20px;
        width: calc(33% - 60px);
    }
    
    .OwnerCourses-wrapper
    {
        background-color: white;
        padding: 10px 10px 0px 10px;
        border-radius: 10px;
    }

    .OwnerCourses-img-area
    { 
        height: 300px; 
        overflow: hidden;
        text-align: center;
    }

    .OwnerCourses-max-booking
    {
        margin: 20px -3px 20px 12px;
        overflow:auto;
        padding-bottom: 10px;
    }

    .OwnerCourses-img-area i
    {
        display:block;
        padding-top: 40px;
        font-size: 60px;
        background-color:aliceblue;
        height: 100vh;
    }

    img
    {
        width: 100%;
    }

    h4{
        margin-bottom:0px;
        padding:10px;
        width: 50%;
        position: absolute;
        bottom: -20px;
        left: 10px;
    }

    @media only screen and (max-width: 1000px) {
        .OwnerCourses-img-area {
            height: auto;
            width: auto;
        }
        
        .OwnerCourses-booking-item
        {
            padding:10px; 
            margin: 30px;
            width: calc(100% - 80px);
        }   
    }
</style>